import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Moment from 'moment-jalali';
import 'bootstrap-v4-rtl/dist/css/bootstrap-rtl.min.css';
import 'bootstrap-v4-rtl/dist/js/bootstrap.min';
import 'popper.js/dist/popper.min.js';
import VueNoty from 'vuejs-noty';
import ToggleButton from "vue-js-toggle-button";
import axios from "axios";
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'material-icons/iconfont/material-icons.css';
import 'material-icons/css/material-icons.css';
import 'font-awesome/css/font-awesome.min.css';
import * as $ from "jquery";
import EventBus from "./_framework/event-bus";
import Constants from "./_framework/Constants";
import wb from "./registerServiceWorker";

Vue.prototype.$workbox = wb;
Vue.mixin({
    data() {
        return {
            userRole: 'user'
        }
    },
    mounted() {
        $(window).on("scroll", () => {
            if ($(window).scrollTop() > 62) {
                if ($(window).width() > 991) {
                    $(".navbar").addClass("navbar-color").addClass("shadow");
                }
                if (!$(".sidebar").hasClass("open") && $(window).width() < 991) {
                    $(".navbar").addClass("navbar-color").addClass("shadow");
                }
            } else {
                $(".navbar").removeClass("navbar-color").removeClass("shadow");
            }
        });
        this.userRole = localStorage.getItem("role");
    },
    methods: {
        onDropDownFocused(val) {
            $(val).find(".dropdown-toggle").addClass("focused");
        },
        onDropDownBlurred(val) {
            $(val).find(".dropdown-toggle").removeClass("focused");
        },
        validateImage(img) {
            if (img === undefined || img === null || img === "" ||
                img.endsWith("default.jpg") || img.endsWith("default.png") ||
                img.endsWith("-.jpg") || img === Constants.BASE_URL + "/") {
                // placeholder
                return require("../public/img/placeholder.jpg");
            } else {
                return img;
            }
        },
        validateImageUrl(img) {
            if (img !== undefined) {
                return Constants.BASE_URL + "/" + img;
            }
        },
        validateDownloadImageUrl(img) {
            if (img !== undefined) {
                return Constants.BASE_URL + img;
            }
        },
        validateDownloadDocImageUrl(img) {
            if (img !== undefined) {
                return Constants.DOC_DOWNLOAD_URL + img;
            }
        },
        validateProfileImage(img) {
            if (img === undefined || img === null || img === "" ||
                img.endsWith("default.jpg") || img.endsWith("default.png") ||
                img.endsWith("-.jpg") || img === Constants.BASE_URL + "/") {
                // placeholder
                return require("../public/img/user-placeholder.png");
            } else {
                return img;
            }
        },
        validateProfilePlaceholder(img) {
            // let final = img.substr(img.lastIndexOf('/') + 1);
            // let file = final.split('.');
            // return "/img/" + file[0] + '.' + file[2];
        },
        validatePrice(price) {
            const formatter = new Intl.NumberFormat('fa-IR', {
                style: 'decimal',
                minimumFractionDigits: 0
            });
            return formatter.format(price) + " ریال";
        },
        gregorianToJalali(val) {
            let date = Moment(val, "YYYY/MM/DD HH:mm");
            return date.format("jYYYY/jMM/jDD HH:mm");
        },
        jalaliToGregorian(val) {
            let date = Moment(val, "jYYYY/jMM/jDD HH:mm");
            return date.format("YYYY/MM/DD HH:mm");
        },
        jalaliToGregorianFormate(val,formate) {
            let date = Moment(val, formate);
            return date.format("YYYY/MM/DD HH:mm");
        },
        gregorianToJalaliBeautified(val, dateTime = false) {
            if (val !== undefined) {
                if (dateTime) {
                    let date = Moment(val, "YYYY/MM/DD HH:mm");
                    return date.format("jDD jMMMM jYYYY HH:mm");
                } else {
                    let date = Moment(val, "YYYY/MM/DD");
                    return date.format("jDD jMMMM jYYYY");
                }
            } else {
                return val;
            }
        },
        unbind(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        removeBase64Comma(base64) {
            return base64.split(",").pop();
        },
        raiseError() {
            this.$noty.error("خطا! لطفا با مدیر سیستم تماس بگیرید");
        },
        redirectTo(name) {
            if (localStorage.getItem("token") === null) {
                this.$router.push({name: 'login'});
            } else {
                this.$router.push({name: `${name}`});
            }
        },
        redirectToByParam(name, parVal) {
            if (localStorage.getItem("token") === null) {
                this.$router.push({name: 'login'});
            } else {
                this.$router.push(
                    {
                        name: `${name}`,
                        params: {
                            param: `${parVal}`
                        }
                    }
                );
            }
        },
            isEmpty(obj) {
                return obj === undefined || obj === null === obj === "";
        }
    },
    beforeRouteLeave(to, from, next) {
        if ($(window).width() < 991) {
            $(".sidebar").removeClass("open");
            $(".wrapper").addClass("wide");
        }
        next();
    }
});

// Components Registration
import Navbar from "./components/Navbar";
import Preloader from "./components/Preloader";
import Spinner from "./components/Spinner";
import Modal from "./components/Modal";
import NoItemAlert from "./components/NoItemAlert";
import TournamentBracket from "./components/TournamentBracket";
import Confirmation from "./components/Confirmation";

Vue.component('navbar', Navbar);
Vue.component('preloader', Preloader);
Vue.component('spinner', Spinner);
Vue.component('modal', Modal);
Vue.component('no-item-alert', NoItemAlert);
Vue.component('tournament-bracket', TournamentBracket);
Vue.component('confirmation', Confirmation);
Vue.use(BootstrapVue);

Vue.use(ToggleButton);
Vue.use(VueNoty, {
    layout: 'topRight',
    theme: 'metroui'
});

Vue.filter('formatGregorianDateToJalaali', function (val) {
    return Moment(val).format('jDD jMMMM jYYYY - HH:mm');
});

Moment.loadPersian({dialect: 'persian-modern'});

/*let theme = localStorage.getItem("theme");
if (theme !== null) {
    import(`./assets/styles/themes/${theme}.scss`);
} else {
    import(`./assets/styles/themes/light.scss`);
}
EventBus.$on("theme", value => {
    localStorage.setItem("theme", value);
    document.location.reload();
});*/

Vue.config.productionTip = false;
axios.defaults.baseURL = window.BASE_URL + '/api';
axios.defaults.headers.common['authorization'] = 'bearer' + localStorage.getItem('token');


let vueInstance = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')

axios.interceptors.response.use((response) => {
        return response;
    }, function (error) {
        //console.log(error.response);
        if (error.response.status === 401 || error.response.status === 403) {
            localStorage.removeItem('userName');
            localStorage.removeItem('token');
            // add router line blow
            router.push({path: '/login', query: {unauthorized: true}});
        }
        if (error.response.status === 400) {
            if (error.response.data.message === "") {
                // vueInstance.$noty.error("خطایی نا مشخص رخ داد");
            }
        }
        return Promise.reject(error.response);
    }
)